(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("webReact", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["webReact"] = factory(require("react"), require("react-dom"));
	else
		root["webReact"] = factory(root["react"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__932__, __WEBPACK_EXTERNAL_MODULE__94__) => {
return 